import styles from "./Buttons.module.css";

const Button = ({ text, disabled, onClick }) => {
  return (
    <button disabled={disabled} className={styles.button} onClick={onClick}>
      {text}
    </button>
  );
};

export default Button;
